import React from "react";
import FormInput from "../widgets/FormInput";
import { cn, getCustomizationValue, showSuccessToast } from "src/lib/utils";
import * as Yup from "yup";
import { Formik } from "formik";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCustomer } from "src/api/customer";
import { usePortalContext } from "src/context/PortalContext";
import { Button } from "../ui/button";
import { useAuth } from "src/providers/AuthProvider";

const validationSchema = Yup.object().shape({
	first_name: Yup.string().required("This field is required"),
	last_name: Yup.string().required("This field is required"),
	phone: Yup.string().required("This field is required"),
	email: Yup.string().required("This field is required"),
	address: Yup.string(),
	// bvn: Yup.string(),
	business_name: Yup.string(),
	business_address: Yup.string(),
});

const NewCustomerModal = ({ onCreate }) => {
	const { user } = useAuth();
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const initialValues = {
		first_name: "",
		last_name: "",
		phone: "",
		email: "",
		address: "",
		// bvn: "",
		business_name: "",
		business_address: "",
	};

	const { mutate, isLoading } = useMutation(createCustomer, {
		onSuccess: ({ message, data }) => {
			showSuccessToast(message);
			if (onCreate) {
				onCreate?.(data);
			}
			queryClient.invalidateQueries(["customers"]);
			closePortal();
		},
	});

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, handleChange, handleSubmit, errors }) => (
				<form onSubmit={handleSubmit} className="tw-grid tw-gap-4">
					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="First Name"
						name="first_name"
						type="text"
						placeholder="First Name"
						value={values.first_name}
						error={errors.first_name}
						onChange={handleChange}
						required
					/>

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Last Name"
						name="last_name"
						type="text"
						placeholder="Last Name"
						error={errors.last_name}
						value={values.last_name}
						onChange={handleChange}
						required
					/>

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Email"
						name="email"
						type="email"
						placeholder="Email"
						error={errors.first_name}
						value={values.email}
						onChange={handleChange}
						required
					/>

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Phone"
						name="phone"
						type="text"
						placeholder="Phone"
						error={errors.phone}
						value={values.phone}
						onChange={handleChange}
						required
					/>

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Address"
						name="address"
						type="text"
						placeholder="Address"
						error={errors.address}
						value={values.address}
						onChange={handleChange}
					/>

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Business Name"
						name="business_name"
						type="text"
						placeholder="Business Name"
						error={errors.business_name}
						value={values.business_name}
						onChange={handleChange}
					/>

					<FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="Business Address"
						name="business_address"
						type="text"
						placeholder="Business Address"
						error={errors.business_address}
						value={values.business_address}
						onChange={handleChange}
					/>

					{/* <FormInput
						className="formItem !tw-w-full !tw-m-0"
						label="BVN"
						name="bvn"
						type="text"
						placeholder="BVN"
						error={errors.bvn}
						value={values.bvn}
						onChange={handleChange}
					/> */}

					<Button type="submit" variant="secondary" disabled={isLoading}>
						{isLoading ? "Creating..." : cn("Create ", getCustomizationValue(user, "customer_label", true))}
					</Button>
				</form>
			)}
		</Formik>
	);
};

export default NewCustomerModal;
